import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './App.css';
import MapChart from './components/Map';
import MainMenu from './components/MainMenu';
import History from './components/History';
import CostCalculator from './components/CostCalculator';
import CarbonCalculator from './components/CarbonCalculator';

function App() {
  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>US Gas Price | Daily Gas Price Updates</title>
          {/* Google Analytics */}
          <script async src="https://www.googletagmanager.com/gtag/js?id=G-LG3YE2VBKP"></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-LG3YE2VBKP');
            `}
          </script>
          <meta property="og:title" content="US Gas Price | Daily Gas Price Updates" />
          <meta property="og:description" content="Get the latest updates on gas prices across the US." />
          <meta property="og:image" content="https://example.com/data-map.png" />
          <meta property="og:url" content="https://usgasprice.com/map" />
          <meta property="og:type" content="website" />
        </Helmet>
        <MainMenu />

        <Routes>
          <Route exact path="/" element={<MapChart />} />
          <Route exact path="/map" element={<MapChart />} />
          <Route path="/cost-calculator" element={<CostCalculator />} />
          <Route path="/carbon-calculator" element={<CarbonCalculator />} />
          <Route path="/history" element={<History />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;